import $ from "jquery";
import {
    currentBrowser,
    createEventListener,
    in_array,
    parse_url,
    parseBool,
} from "./tools";
import moment from "moment";
import "./knockout.binding";
import "./components";
import Entity from "./entity";
import {
    localeGet, exchangeKey, kasperskyIp, eventGet, cometGet,
    loginGuest, checkAllowedEmail, clientRoleCheck,
    getConnection, getTicket, loginWithAccessToken
} from "./api";
import storage from "./storage";
// import "../style/style.less";
import "../style-v2/style.scss";
import tokenStorage from "./tokenStorage";

const regionalServers = [1, 77,78,79,80,81,82,83,84];
const allowedRegions = [
    'AD', // Адыгея
    // 'AL', // Алтай +
    // 'ALT', // Алтайский край +
    // 'AMU', // Амурская область +
    'ARK', // Архангельская область
    'AST', // Астраханская область
    'BA', // Башкортостан
    'BEL', // Белгородская область
    'BRY', // Брянская область
    // 'BU', // Бурятия +
    'CE', // Чечня
    // 'CHE', // Челябинская +
    // 'CHU', // Чукотский АО +
    'CU', // Чувашия
    'DA', // Дагестан
    'IN', // Ингушетия
    // 'IRK', // Иркутская область +
    'IVA', // Ивановская область
    // 'KAM', // Камчатский край +
    'KB', // Кабардино-Балкария
    'KC', // Карачаево-Черкессия
    'KDA', // Краснодарский край
    // 'KEM', // Кемеровская область +
    'KGD', // Калининградская область
    // 'KGN', // Курганская область +
    // 'KHA', // Хабаровский край +
    // 'KHM', // Ханты-Мансийский АО +
    'KIR', // Кировская область
    // 'KK', // Хакасия +
    'KL', // Калмыкия
    'KLU', // Калужская область
    'KO', // Коми
    'KOS', // Костромская область
    'KR', // Карелия
    'KRS', // Курская область
    // 'KYA', // Красноярский край +
    'LEN', // Ленинградская область
    'LIP', // Липецкая область
    // 'MAG', // Магаданская область +
    'ME', // Марий Эл
    'MO', // Мордовия
    'MOS', // Московская область
    'MOW', // Москва
    'MUR', // Мурманская область
    'NEN', // Ненецкий АО
    'NGR', // Новгородская Область
    'NIZ', // Нижегородская область
    // 'NVS', // Новосибирская область +
    // 'OMS', // Омская область +
    'ORE', // Оренбургская область
    'ORL', // Орловская область
    'PER', // Пермский край
    'PNZ', // Пензенская область
    // 'PRI', // Приморский край +
    'PSK', // Псковская область
    'ROS', // Ростовская область
    'RYA', // Рязанская область
    // 'SA', // Саха (Якутия) +
    // 'SAK', // Сахалин +
    'SAM', // Самарская область
    'SAR', // Саратовская область
    'SE', // Северная Осетия
    'SMO', // Смоленская область
    'SPE', // Санкт-Петербург
    'STA', // Ставрополье
    // 'SVE', // Свердловская область +
    'TA', // Татарстан
    'TAM', // Тамбовская область
    // 'TOM', // Томская область +
    'TUL', // Тульская область
    'TVE', // Тверская область
    // 'TY', // Тува +
    // 'TYU', // Тюмень +
    'UD', // Удмуртия
    'ULY', // Ульяновская область
    'VGG', // Волгоградская область
    'VLA', // Владимирская область
    'VLG', // Вологодская область
    'VOR', // Воронежская область
    // 'YAN', // Ямало-Ненецкий АО +
    'YAR', // Ярославская область
    // 'YEV', // Еврейская АО +
    // 'ZAB', // Забайкальский Край +
];

const APP_PAGES = {
    BROWSER_ERROR: 'browser-error',
    LOGIN: 'login',
    LOADING: 'loading',
    AUTH_DOMAIN_DENIED: 'authDomainDenied',
    ACCESS_NOT_ALLOWED: 'accessNotAllowed',
    PLAYER: 'player',
};

const hexToRGBArray = (hex) => {
    hex = hex.replace('#');
    if (hex.length === 3) {
        hex = hex[0] + hex[0] + hex[1] + hex[1] + hex[2] + hex[2];
    }

    return [
        parseInt(hex.substring(0, 2), 16),
        parseInt(hex.substring(2, 4), 16),
        parseInt(hex.substring(4, 6), 16),
    ];
}

class Application {
	constructor() {
		createEventListener(this);
		this.VERSION = 'dev';
		this.broadcastDelay = 40;
		this.event = ko.observable();
		this.ticketKey = ko.observable();
		this.ticketVerify = ko.observable();
		this.episode = ko.observable();
        this.geoLocation = ko.observable(null);
		this.request = parse_url(location.href);
        this.browser = currentBrowser;

		this.debug = location.host.match(/dev/) || this.request.getParameter('debug', false);
		this.log = console.debug.bind(console);

		Entity.$app = this;

		this.page = ko.observable('loading');

		this.currentStream = ko.observable(null);
		this.currentStreamDay = ko.observable(0);
		this.currentEpisode = ko.observable(null);

		this.currentEpisode.subscribe(episode => this.trigger('currentEpisode', [episode]));
		this.currentStream.subscribe(stream => this.trigger('currentStream', [stream]));
		this.currentStreamDay.subscribe(day => this.trigger('currentStreamDay', [day]));

		this.nextStream = ko.observable(null);
		this.nextEpisode = ko.observable(null);

		// back compatibility
		this.compactPlayer = {
			get: () => this.require('ui').playerSize.isCompact(),
			set: () => this.require('ui').playerSize.isCompact(true),
			show: () => this.require('ui').playerSize.isCompactShow(true),
			hide: () => this.require('ui').playerSize.isCompactShow(false),
		};

		this.isEventStarted = ko.observable(false);

		this.showCookieMessage = ko.observable(true);

		this.cookieEnabled = ko.computed(() => true);

		this.hideCookieMessage = () => this.showCookieMessage(false);

		ko.computed(() => {
			if (!this.event()) return;

			const keys = ['accentColor', 'textColor', 'backgroundColor', 'borderColor', 'playerTextColor', 'playerBackgroundColor', 'timeLineEpisodeColor', 'episodeTextColor', 'episodeBackgroundColor'];
			const theme = this.event().moduleTheme;

			let query = {
				eventKey: this.event().eventKey(),
				version: this.VERSION
			};

			if (theme.fontFamily) {
				query.fontFamily = theme.fontFamily.name;
			}
			if (theme.fontSize) {
				query.fontSize = theme.fontSize;
			}

			keys.forEach(key => query[key] = theme[key]());

			let queryString = Object.keys(query)
				.filter(name => query[name])
				.map(name => name + '=' + query[name].replace(/^#/, ''))
				.join('&')
			;

			document.getElementById('main-style')
                .setAttribute('href', '/api/player/event/' + this.event().eventKey() + '/style?' + queryString)
            ;

            let themeName = 'dark';
            let accentColor = hexToRGBArray(theme.accentColor());
            let darkColor = hexToRGBArray(theme.backgroundColor());
            let lightColor = hexToRGBArray(theme.textColor());
            if ((darkColor[0] + darkColor[1] + darkColor[2]) / 3 > 127) {
                themeName = 'light';
            }
            document.body.classList.add(`theme-${themeName}`);
            const styleElement = document.querySelector(':root').style;
            styleElement.setProperty('--app-accent-color-rgb', accentColor);
            styleElement.setProperty('--app-color-dark-rgb', darkColor);
            styleElement.setProperty('--app-color-light-rgb', lightColor);
		});

        ko.computed(() => {
            Object.keys(APP_PAGES).forEach((key) => document.body.classList.remove(`page-${APP_PAGES[key]}`));
            document.body.classList.add(`page-${this.page()}`);
        });
	}

	isBrowserSupported() {
		const supportedBrowsers = {
			'Internet Explorer': 9,
			'Chrome': 35,
			'Firefox': 29,
			'Opera': 21,
			'Safari': 7
		};
		return !(currentBrowser.name in supportedBrowsers) || (supportedBrowsers[currentBrowser.name] <= currentBrowser.version);
	}

	require(...modules) {
		const callback = typeof modules[modules.length - 1] === 'function' ? modules.pop() : () => {};

		modules = modules.map(moduleName => {
			moduleName = moduleName.replace(/^\$/, '');
			if (moduleName === 'app') return this;
			return this['$' + moduleName] || (this['$' + moduleName] = new (require(`./${moduleName}`).default)(this));
		});

		callback.apply(this, modules);
		return modules[0];
	}

	setLocale(name) {
		Entity.localeName(name);
		moment.locale(name);
		return this;
	}

	startModules() {
		try {
			this.require(
				'activity', 'auth', 'banner', 'comet', 'comment', 'embed',
				'episode', 'episodeSelect', 'episodeSchedule', 'episodeTable', 'episodeFavorite',
				'information', 'instagram', 'notification', 'overlay', 'player',
				'poll', 'question', 'share', 'statistic', 'twitter', 'ui', 'playerNotification', 'presence'
			);
		} catch (e) {
			console.error(e);
		}

		return this;
	}

	setVersion(version) {
		this.VERSION = version;
		return this;
	}


	getVersion() {
		return this.VERSION;
	}

	setStream(stream) {
		this.isEventStarted(true);
		this.trigger('setStream', [stream]);
		return this;
	}

	setEpisode(episode) {
		this.isEventStarted(true);
		this.trigger('setEpisode', [episode]);
		return this;
	}

	playerSize(size) {
		this.require('ui').playerSize.set(size);
		return this;
	}

	resetEpisodeLikes() {
		this.event().episode()
			.filter(episode => episode.liked())
			.forEach(episode => episode.liked(false));
		return this;
	}

	showTicketError(statusCode) {
		const ticketError = $('#ticket-error');
		const ticketErrorDefault = $('.ticket-error-default');
		const ticketErrorNotFound = $('.ticket-error-notFound');
		const ticketErrorDisabled = $('.ticket-error-disabled');
		const hidingModules = $('#page-loading, #topModules, #bottomModules, #episodeTable, #episodeSelect');

		hidingModules.remove();
		ticketError.show();
		switch (statusCode) {
			case 404:
				ticketErrorDefault.hide();
				ticketErrorNotFound.show();
				break;
			case 403:
				ticketErrorDefault.hide();
				ticketErrorDisabled.show();
				break;
		}
	};

	start(watchKey, options) {
		Promise.resolve()
			.then(async () => {
				const localeName = Entity.localeName();

				if (window.locale && window.locale[localeName]) {
                    this.log('Локаль уже загружена');
					return;
				}

				this.log('Загрузка локали', localeName);
				const locale = await localeGet(localeName);
                window.locale = {[localeName]: locale};
			})
			.then(() => {
				if (this.isBrowserSupported()) {
                    return;
                }
                this.page(APP_PAGES.BROWSER_ERROR);
                throw new Error('Browser not supported');
			})
			.then(async () => {
                try {
                    const {eventKey, verify, geoLocation} = await exchangeKey(watchKey)
                    if (verify) {
                        this.ticketVerify(verify);
                    }
                    if (geoLocation) {
                        this.geoLocation(geoLocation);
                    }
                    if (!eventKey) {
                        throw new Error('Cant exchange watchKey');
                    }

                    return eventKey;
                } catch({status}) {
                    switch (status) {
                        case 402:
                            setTimeout(() => this.showTicketError(404), 100);
                            break;
                    }
                    throw new Error('Cant exchange watchKey');
                }
			})
			.then(async (eventKey) => {
                tokenStorage.setEventKey(eventKey);

                if (65 === options.eventClientId) {
                    const ip = await kasperskyIp();
                    this.request.params.ip = ip.trim();
                }

                this.log('Загрузка данных трансляции');
				const params = {
					ip: this.request.getParameter('ip'),
				};
                const event = await eventGet(eventKey, params);

                this.log('Форматирование данных трансляции');
                Object.keys(event['moduleTheme']).forEach(key => {
                    if (key.match(/Color$/) && this.request.getParameter(key)) {
                        event.moduleTheme[key] = this.request.getParameter(key);
                    }
                });

                event.stream.forEach(stream => {
                    stream.quality = stream.quality.filter(quality => quality.enabled);
                    stream.language = stream.language.filter(language => language.enabled);
                });

                if (!(this.geoLocation()?.countryCode === 'RU' && -1 !== allowedRegions.indexOf(this.geoLocation()?.subdivisionCode))) {
                    event.stream.forEach(stream => {
                        if (!stream.liveProfile) {
                            return;
                        }
                        stream.liveProfile.viewServer = stream.liveProfile.viewServer
                            .filter(server => -1 === regionalServers.indexOf(server.server.id));
                    });
                }

                this.event(new Entity.Event(event));
                Entity.Client.prototype.nicknameFormat(this.event().moduleAuth.nickname());

                switch (watchKey.substr(0, 1)) {
                    case 't':
                        this.ticketKey(watchKey);
                        break;

                    case 'r':
                        this.episode(this.event().episode().find(episode => episode.key() === watchKey));
                        this.event().stream().forEach(stream => stream.episode([]));
                        this.event().stream([this.episode().stream()]);
                        break;
                }
			})
			.then(async () => {
				this.log('Загрузка списка кометов');
				const servers = await cometGet(this.event().eventKey());
                this.require('comet').setServers(servers);
			})
			.then(() => {
				this.log('Запуск модулей');
				this.startModules();
			})
			.then(() => {
				this.log('Начало биндинга данных');
				ko.applyBindings(this);
			})
			.then(() => {
				this.require('comet').join(this.event().eventKey());
			})
            .then(() => {
                if (this.request.getParameter('accessToken')) {
                    return loginWithAccessToken(this.event().eventKey(), this.request.getParameter('accessToken'));
                }
            })
			.then(async () => {
                let client = this.require('auth').client();
                if (client || !this.request.getParameter('name') || !this.event().moduleAuth.guest()) {
                    return;
                }
                try {
                    let info = {
                        name: decodeURI(this.request.getParameter('name'))
                    };

                    let registration_form = this.request.getParameter('registration_form', false);
                    if (registration_form) {
                        try {
                            let data = JSON.parse(decodeURIComponent(registration_form));
                            info = {
                                ...data,
                                ...info,
                                externalLogin: true,
                            };
							this.event().registrationFields()?.filter(field => field.type() === 'disclaimer' && field.required()).forEach(field => info[field.name()] = true);
                        } catch (e) {}
                    }

                    return await loginGuest(this.event().eventKey(), info);
                } catch(e) {}
			})
			.then(() => { // Проверка обязательной авторизации
				this.log('Проверка регистрации');

				const $auth = this.require('auth');

				if (this.request.getParameter('noReg') || $auth.isLoggedIn() || !this.event().moduleAuth.require()) {
                    return;
                }

                return new Promise(resolve => {
                    this.page(APP_PAGES.LOGIN);
                    const subscription = $auth.isLoggedIn.subscribe((isLoggedIn) => {
                        if (!isLoggedIn) {
                            return;
                        }

                        try {
                            const yaCode = this.event().moduleBranding.yandexMetrika();
                            if (yaCode && window['yaCounter' + yaCode]) {
                                window['yaCounter' + yaCode]['reachGoal']('Registration');
                            }
                            if (window.ga && window.ga.getByName && window.ga.getByName('clientTracker')) {
                                window.ga('clientTracker.send', 'event', 'BroadcastPlayer', 'registration');
                            }
                            if ('dataLayer' in window && window.dataLayer.push) {
                                window.dataLayer.push({event: 'registration'});
                            }
                        } catch (e) {}

                        this.page(APP_PAGES.LOADING);
                        resolve();
                        subscription.dispose();
                    });
                });
			})
			.then(() => { // Проверка домена почты авторизации
				if (this.request.getParameter('noReg')) {
					return;
				}

				const allowedEmailDomain = this.event().moduleAuth.allowedEmailDomain().trim().toLowerCase();
				if (!allowedEmailDomain.length) {
                    return;
                }

                const $auth = this.require('auth');
                const email = $auth.client() && ($auth.client().email() || $auth.client().info().email) || '';
                const domain = email.split('@')[1]?.toLowerCase() || '';
                if (allowedEmailDomain.split(/[\s;,]+/).indexOf(domain.toLowerCase()) < 0) {
                    this.page(APP_PAGES.AUTH_DOMAIN_DENIED);
                    return new Promise(() => {});
                }
			})
			.then(async () => {
				const $auth = this.require('auth');
				if (this.request.getParameter('noReg') || !this.event().moduleAuth.accessByEmails()) {
					return;
				}

				const response = await checkAllowedEmail(this.event().eventKey());
                if (response.success) {
                    return;
                }

                return new Promise(resolve => {
                    if ($auth.isLoggedIn()) {
                        this.page(APP_PAGES.AUTH_DOMAIN_DENIED);
                    } else {
                        this.page(APP_PAGES.LOGIN);
                    }
                    const subscription = $auth.isLoggedIn.subscribe((isLoggedIn) => {
                        if (!isLoggedIn) {
                            return;
                        }

                        this.page(APP_PAGES.LOADING);
                        resolve();
                        subscription.dispose();
                    });
                });
			})
			.then(async () => { // Проверка роли
				const $auth = this.require('auth');
				if (this.request.getParameter('noReg')) {
					return;
				}

				const accessPreModeration = this.event().moduleAuth.accessPreModeration();
				if (false === accessPreModeration) {
					return;
				}

				const response = await clientRoleCheck(this.event().eventKey());
                if (response.accessAllowed) {
                    return;
                }

                return new Promise(resolve => {
                    if ($auth.isLoggedIn()) {
                        this.page(APP_PAGES.ACCESS_NOT_ALLOWED);
                    } else {
                        this.page(APP_PAGES.LOGIN);
                    }
                    const subscription = $auth.isLoggedIn.subscribe((isLoggedIn) => {
                        if (!isLoggedIn) {
                            return;
                        }

                        this.page(APP_PAGES.LOADING);
                        resolve();
                        subscription.dispose();
                    });
                });
			})
			.then(() => {
				parent.postMessage(JSON.stringify({isRegistered: true}), '*');
				this.log('Запуск сессии просмотра');
				const eventKey = this.event().eventKey();
				const referrer = document.referrer;
                const pageReferrer = this.request.getParameter('referrer', null);
                const utm = {};

                (new URLSearchParams(window.location.search)).forEach((value, key) => {
                    if (0 === key.indexOf('utm_')) {
                        utm[key] = value;
                    }
                });

				return getConnection({eventKey, referrer, pageReferrer, ...utm})
					.then(statisticSession => {
						this.require('comet').join(statisticSession.cometChannel);
						this.require('statistic').setCometChannel(statisticSession.cometChannel);
					});
			})
			.then(() => {
				if (this.ticketKey()) {
					this.require('comet')
						.join(this.ticketKey())
						.on('update:ticket', () => {
							setTimeout(() => {
								getTicket(this.ticketKey(), this.ticketVerify())
                                    .catch(({statusText}) => {
                                        this.showTicketError(statusText)
                                    })
							}, 5000);
						})
					;
				}
			})
			.then(() => { // Запуск приложения
				this.log('Отправка события start');
				this.trigger('start');
				console.log('Player Start');

				if (this.event().episode().length && this.event().moduleEpisode.showTable()) {
					this.require('episodeTable').show();
				}

				const stream = this.event().getStartStream();
				if (stream
					&& (stream.broadcastSession().length && stream.broadcastSession()[0].timeStart() < Math.round(Date.now() / 1000) - this.broadcastDelay)
					&& stream.status() === 'live') {
					this.isEventStarted(true);
				}

				this.require('player')
					.on('currentTime', currentTime => {
						if (this.episode()) {
							if (currentTime > this.episode().playerTimeStop()) {
								this.setStream(null);
							}
						} else if (this.currentStream() && this.currentStream().dvr()) {
							if (this.currentEpisode() && this.currentEpisode().isRecorded()) {
							} else if (this.currentStream().isRecorded() && this.currentStream().isEpisodeRecorded() && (this.currentEpisode() && this.currentEpisode().isRecorded())) {
							} else {
								const playerEpisode = this.currentStream().getEpisodeByPlayerTime(currentTime, this.currentStreamDay());
								if (playerEpisode !== this.currentEpisode()) {
									this.currentEpisode(playerEpisode);
								}
							}
						} else if (this.currentStream()) {
							const playerEpisode = this.currentStream().getEpisodeByPlayerTime(this.require('player').duration(), this.currentStreamDay());
							if (playerEpisode !== this.currentEpisode()) {
								this.currentEpisode(playerEpisode);
							}
						}
					})
					.on('ended', () => {
						const currentEpisode = this.currentEpisode();
						const currentStream = this.currentStream();
						const $overlay = this.require('overlay');

						if (this.episode()) {
							this.setStream(null);
						} else if (this.event().isEpisodeRecorded()) {
							if (currentEpisode) {
								const nextEpisode = currentEpisode.getNextEpisode();
								const nextStream = currentEpisode.stream().getNextStream();
								const nextStreamEpisode = nextStream && nextStream.episode()[0];

								if (nextEpisode) {
									this.setEpisode(nextEpisode);
								} else if (nextStreamEpisode) {
									this.setEpisode(nextStreamEpisode);
								} else {
									//this.nextEpisode(this.event().stream()[0].episode()[0]);
									//this.nextStream(this.nextEpisode().stream());
									this.setStream(null);
									$overlay.setPlayHandler(() => this.setEpisode(this.nextEpisode()), 0);
								}
							}
						} else if (currentStream.getNextStream()) {
							this.setStream(currentStream.getNextStream());
						} else {
							this.nextStream(this.event().stream()[0]);
							this.setStream(null);
							$overlay.setPlayHandler(() => this.setStream(this.nextStream()), 0);
						}
					})
				;

				storage.clearExpired();
				this.page(APP_PAGES.PLAYER);

				this.event().stream().forEach(stream => stream.status.subscribe(status => {
                    if (stream !== this.currentStream() || status !== 'stop') {
                        return;
                    }

                    let nextStream = this.event().getStartStream();
                    if (nextStream && nextStream.status() === 'stop') {
                        nextStream = null;
                    }
                    setTimeout(() => {
                        if (stream !== this.currentStream() || this.currentStream().status() !== 'stop') {
                            return;
                        }

                        this.setStream(nextStream)
                    }, this.broadcastDelay * 1000);
				}));

				if (stream) {
					return stream;
				}

				return new Promise(resolve => {
					this.log('Ожидание старта потока');
					const subscriptions = this.event().stream().map(stream => {
						return stream.status.subscribe(status => {
							if (status === 'live') {
								subscriptions.forEach(subscription => subscription.dispose());
								const delay = !stream.broadcastSession()[0] || stream.broadcastSession()[0].timeStart() > (Math.round(Date.now() / 1000) - this.broadcastDelay) ? this.broadcastDelay : 0;
								setTimeout(() => resolve(stream), delay * 1000);
							}
						});
					});
				});
			})
			.then(stream => {
				const $overlay = this.require('overlay');

				this.log('Запуск просмотра');

				if (this.episode()) {
					this.nextEpisode(this.episode());
					this.nextStream(this.episode().stream());
					$overlay.setPlayHandler(() => this.setEpisode(this.episode()), 0);
					switch (this.episode().type()) {
						case 'live':
							this.setEpisode(this.episode());
							break;
						case 'idle':
							const episodeLiveSubscribe = this.episode().type.subscribe((type) => {
								if (type === 'live') {
									episodeLiveSubscribe.dispose();
									setTimeout(() => this.setEpisode(this.episode()), this.broadcastDelay * 1000);
								}
							});
					}
				} else if (in_array(stream.status(), ['live', 'pause']) && parseBool(this.request.getParameter('autoplay', true))) {
					this.setStream(stream);
				} else {
					this.nextStream(stream);
					let playHandler = () => this.setStream(this.nextStream());

					if (this.episode()) {
						this.nextEpisode(this.episode());
						this.nextStream(this.nextEpisode().stream());
						playHandler = () => this.setEpisode(this.nextEpisode());
					} else if (this.event().episode().length && this.event().episode()[0].isRecorded()) {
						this.nextEpisode(stream.episode()[0]);
						this.nextStream(this.nextEpisode().stream());
						playHandler = () => this.setEpisode(this.nextEpisode());
					}

					$overlay.setPlayHandler(playHandler, 0);
				}
			})
			.catch((err) => {
				console.log(err);
				console.error('Failed to start Player Application');
			})
		;
	}
}


window.ko = ko;
window.$ = window.jQuery = $;
window.moment = moment;

export default Application;
